import { render, staticRenderFns } from "./CreateClientPortfolios.vue?vue&type=template&id=539d8a16"
import script from "./CreateClientPortfolios.vue?vue&type=script&lang=js"
export * from "./CreateClientPortfolios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports